import styled from "styled-components";
import { motion } from "framer-motion";

export const BodyTurnosDeldiaLabo = styled(motion.div)`
  width: 100%;
  height: 500px;
  padding-top: 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: scroll;

  button {
    border-radius: 8px;
    background-color: var(--color-primary);
    color: var(--color-white);
    width: 320px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
    position: absolute;
    bottom: 30px;
  }
  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 26px;
    line-height: 150%;
    text-align: center;
    color: var(--color-latex10);
  }
`;
